import css from 'styled-jsx/css';
import { colorPalette } from 'styles/css-constants';
import { sharedPalette } from 'styles/colors/constants';

export default css`
  amp-sidebar {
    width: 50vw;
    max-width: 375px;
    padding: 0.75rem;
    background-color: #fff;
    box-shadow: 2px 0px 6px #999;
  }

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding: 0.5rem;
  }

  .AmpHeader__button {
    font-size: 1.5em;
    border: none;
    padding: 0;
    background-color: transparent;
    color: #000;
  }

  .AmpHeader__hamburger-close {
    font-size: 1.25em;
  }

  .AmpHeader__hamburger-open {
    grid-area: hamburger;
  }

  .AmpHeader__logo {
    grid-area: logo;
    margin: 0 auto;
    width: 140px;
  }

  .AmpHeader__logo--at {
    width: 216px;
  }

  .HamburgerNav nav {
    margin-bottom: 1rem;
    border-bottom: 1px solid #ddd;
    padding-bottom: 1rem;
  }

  .HamburgerNav ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .AmpHeader__xsite-link {
    font-family: sans-serif;
    font-size: 12px;
  }

  .AmpHeader__xsite-link :global(a) {
    margin-top: 0.25rem;
    display: block;
    width: 120px;
  }

  :global(.cb) .AmpHeader {
    position: relative;
    align-items: stretch;
    background-color: ${colorPalette.beige};
  }

  :global(.cb) header {
    padding: 0;
  }

  :global(.cb) .AmpHeader__button {
    display: none;
  }

  :global(.cb) .AmpHeader__logo {
    order: 1;
    margin: 0 4px 0 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 0 0 0 1.5rem;
    background-color: ${sharedPalette.cbYellow};
  }

  :global(.cb) .AmpHeader[data-page-path^='/about'] .AmpHeader__logo {
    background-color: transparent;
  }

  :global(.cb) .AmpHeader__logo :global(svg) {
    margin-top: 4px;
    height: 56px;
    fill: #fff;
  }

  :global(.cb) .AmpHeader::after {
    content: '';
    order: 2;
    margin-right: 4px;
    display: block;
    height: 0;
    width: 0;
    border-bottom: 76px solid ${colorPalette.greenAccent};
    border-left: 76px solid transparent;
  }

  :global(.cb) .AmpHeader__actions {
    order: 3;
    margin: 0;
    display: flex;
    flex-direction: column;
  }

  :global(.cb) .AmpHeader__actions::before {
    content: '';
    display: block;
    width: 76px;
    height: 38px;
    background-color: ${colorPalette.lavendarAccent};
    border-radius: 0 0 38px 38px;
  }

  :global(.cb) .AmpHeader__actions::after {
    content: '';
    display: block;
    width: 76px;
    height: 38px;
    background-color: ${colorPalette.lavendarAccent};
    border-radius: 38px 38px 0 0;
  }
`;
